import { render, staticRenderFns } from "./MaterialProductionInfo.vue?vue&type=template&id=c0e28980&scoped=true&"
import script from "./MaterialProductionInfo.vue?vue&type=script&lang=js&"
export * from "./MaterialProductionInfo.vue?vue&type=script&lang=js&"
import style0 from "./MaterialProductionInfo.vue?vue&type=style&index=0&id=c0e28980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e28980",
  null
  
)

export default component.exports